import { useTranslation } from "react-i18next"
import { PermissionAsssignmentProps } from "./types"
import { useStyles } from "./styles"
import { Box, Button, Typography } from "@mui/material"
import { LoadingButton } from "@mui/lab"
import { CustomTable } from "../../../table"
import Loader from "../../../loader"
import { icons } from "../../../../utils/icons"
import { FiltersDrawer } from "../../../filtersDrawer"
import { useContextState } from "../../../../hooks/theme"



export const PermissionAsssignment = (props: PermissionAsssignmentProps) => {
    const { t } = useTranslation()
    const styles = useStyles()
    const { colors } = useContextState()

    return (
        <Box>
            {props.haveButtons &&
                <Box sx={styles.containerButtons}>
                    <Button onClick={() => { if(props.handleCancel){ props.handleCancel() } }}>{t('general.cancel')}</Button>

                    <Box sx={styles.finishBtn}>
                        {
                            !!props.deleteSelected?.length && (
                                <Button
                                    /* disabled={generalDisabled(createEdit, data)} */
                                    onClick={props.deletedUsersSelecteds}
                                    variant="container_error"
                                >
                                    {t('general.deleteSelected')}
                                </Button>
                            )
                        }

                        <LoadingButton
                            /* disabled={generalDisabled(createEdit, data)} */
                            onClick={() => {
                                if(props.handleSubitmit){
                                    props.handleSubitmit()
                                }
                            }}
                            loading={props.submitLoading}
                            variant="contained"
                        >
                            {t('general.save')}
                        </LoadingButton>
                    </Box>
                </Box>
            }

            {
                (!!props.deleteSelected?.length && !props.haveButtons) &&
                <Box sx={styles.finishBtnDerlete}>
                    <Button
                        /* disabled={generalDisabled(createEdit, data)} */
                        onClick={props.deletedUsersSelecteds}
                        variant="container_error"
                    >
                        {t('general.deleteSelected')}
                    </Button>
                </Box>
            }


            <Box sx={styles.titleFolio}>
                <Box sx={styles.all}>
                    <Typography
                        sx={styles.select}
                        onClick={() => {
                            props.unSelectOrSelectAllUsersFolios({ value: true })
                        }}
                    >
                        {t('schedule.buttons.addTruechecket')}
                    </Typography>

                    <Typography sx={styles.line}>|</Typography>

                    <Typography
                        sx={styles.select}
                        onClick={() => {
                            props.unSelectOrSelectAllUsersFolios({ value: false })
                        }}
                    >
                        {t('schedule.buttons.addFalsechecket')}
                    </Typography>
                </Box>
            </Box>

            {/* TABLE */}
            {!props.loadingTable ?
                <CustomTable
                    tableChecks
                    defaultChecks={props.deleteSelected}
                    onClick={(payload) => {
                        props.setDeletedSelected(payload?.checks ?? [])
                    }}
                    dontRefresh
                    name={t('general.tags.departments')}
                    column={props.columnFolio}
                    row={props.rowFiltered}
                    color={colors}
                    noContent={t('filesManager.messages.withoutUserWithPermissions')}
                    iconsNoContent={icons('userAccount')}
                    selected={-1} />
                : <Loader />}


            <FiltersDrawer cleanFilter={props.cleanFilter} count={props.counter} right={-74} top={0}>
                <Box sx={styles.section}>
                    {props.floatItems}
                </Box>
            </FiltersDrawer>
        </Box>
    )
}